const PREFIX = "[chatWebSocket]";

export const WS_WARN = {
  NO_TOKEN: `${PREFIX} 토큰이 없어 연결하지 않습니다. 먼저 로그인 후 호출해 주세요.`,
  AUTH_FAILURE: `${PREFIX} 인증 실패. 재로그인 또는 토큰 재발급 후 다시 연결해 주세요.`,
  TOTAL_UNREAD_COUNT_FAIL: `${PREFIX} 전체 unread 개수 조회 실패`,
  MESSAGE_HISTORY_FAIL: `${PREFIX} 메시지 이력 조회 실패`,
  MESSAGE_SEND_FAIL: `${PREFIX} 메시지 전송 실패`,
  MESSAGE_PARSE_FAIL: `${PREFIX} 메시지 파싱 실패`,
};

export const WS_ERROR = {
  CONNECTION: `${PREFIX} 오류`,
};
